/**
 * MessageRouterCase - Router for case-specific messages (/cases/:id/messages)
 */

import React from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { MessageListPage, MessageDetailsPage } from './components';
import { queryClient } from 'config/queryClient';
import { MessageProvider } from './context';

function MessageRouterCase(props) {
  const { path } = useRouteMatch();

  return (
    <QueryClientProvider client={queryClient}>
      <MessageProvider {...props} isFromCase>
        <Switch>
          <Route exact path={path} component={MessageListPage} />
          <Route path={`${path}/:message_id`} component={MessageDetailsPage} />
        </Switch>
      </MessageProvider>
    </QueryClientProvider>
  );
}

export default MessageRouterCase;
